import type { SerializedAttendee } from '@pique/core/modules/properties/services/schema';

export interface DemoAttendee {
  email: string;
  name: string;
  avatar: string;
}

export interface DemoSocialFeedItem {
  attendeeEmail: string;
  text: string;
  confidence: number;
  category: string;
  date: string;
}

export interface DemoTranscriptChunk {
  speakerEmail: string;
  timestamp: string;
  text: string;
}

export interface DemoActionItem {
  title: string;
  assignedToEmail: string;
  status?: string;
  priority?: string;
  daysOverdue?: number;
}

export interface DemoPreviousNote {
  id: string;
  title: string;
  forEventId: string;
  daysAgo: number;
  attendeeEmails: string[];
  transcript: DemoTranscriptChunk[];
  socialFeedItems: DemoSocialFeedItem[];
  actionItems?: DemoActionItem[];
  overview?: string;
  briefSummary?: string;
}

export interface DemoTemplate {
  id: string;
  name: string;
  description: string;
  selfAttendeeEmail: string;
  attendees: DemoAttendee[];
  previousNotes: DemoPreviousNote[];
}

export function createDemoAttendee(demo: DemoAttendee): SerializedAttendee {
  return {
    id: `demo_${demo.email.split('@')[0]}`,
    name: demo.name,
    email: demo.email,
    avatar: demo.avatar,
    present: true,
    self: false,
  };
}
